if (!customElements.get('card-inline-sizes')) {
  class CardInlineSizes extends HTMLElement {
    connectedCallback() {
      this.stockEl = this.querySelector('[data-stock]');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.submitBtn = this.querySelector('[data-submit]');
      this.submitLabel = this.submitBtn?.querySelector('span:not(.sold-out-message)');
      this.soldOutMessage = this.submitBtn?.querySelector('.sold-out-message');
      this.lowStockThreshold = Number(this.dataset.lowStockThreshold || 5);
      this.labelInStockPrefix = this.dataset.labelInStockPrefix || 'En stock: ';
      this.labelInStockUntracked = this.dataset.labelInStockUntracked || 'En stock';
      this.labelLowStock = this.dataset.labelLowStock || 'Dernières pièces !';
      this.labelSoldOut = this.dataset.labelSoldOut || 'Épuisé';
      this.labelAdd = this.dataset.labelAdd || 'Ajouter au panier';
      this.priceRoot = this.findPriceRoot();

      this.querySelectorAll('.card-inline-sizes__option').forEach((button) => {
        button.addEventListener('click', () => {
          this.selectOption(button);
        });
      });
    }

    findPriceRoot() {
      const card = this.closest('product-component, .card-wrapper, .card');
      return card?.querySelector('[data-card-price]') || null;
    }

    selectOption(button) {
      if (button.disabled) {
        return;
      }

      this.querySelectorAll('.card-inline-sizes__option').forEach((el) => {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');

      const available = button.dataset.available === 'true';
      const tracked = button.dataset.inventoryTracked === 'true';
      const inventory = Number(button.dataset.inventory || 0);

      this.variantInput.value = button.dataset.variantId;
      this.variantInput.disabled = !available;
      this.updatePrice(button);

      if (this.soldOutMessage) {
        this.soldOutMessage.classList.add('hidden');
      }
      if (this.submitLabel) {
        this.submitLabel.classList.remove('hidden');
      }

      if (!available) {
        this.setStockState(this.labelSoldOut, false);
        this.submitBtn.disabled = true;
        this.submitBtn.setAttribute('aria-disabled', 'true');
        if (this.submitLabel) {
          this.submitLabel.textContent = this.labelSoldOut;
        }
        return;
      }

      if (!tracked) {
        this.setStockState(this.labelInStockUntracked, false);
      } else if (inventory < this.lowStockThreshold) {
        this.setStockState(this.labelLowStock, true);
      } else {
        this.setStockState(`${this.labelInStockPrefix}${inventory}`, false);
      }

      this.submitBtn.disabled = false;
      this.submitBtn.removeAttribute('aria-disabled');
      if (this.submitLabel) {
        this.submitLabel.textContent = this.labelAdd;
      }
    }

    updatePrice(button) {
      if (!this.priceRoot) {
        return;
      }

      const priceEl = this.priceRoot.querySelector('.price');
      const saveEl = this.priceRoot.querySelector('[data-card-price-save]');
      if (!priceEl) {
        return;
      }

      const priceMoney = button.dataset.priceMoney || '';
      const compareMoney = button.dataset.compareMoney || '';
      const onSale = button.dataset.onSale === 'true' && Boolean(compareMoney);
      const saveLabel = button.dataset.saveLabel || '';

      const regularPrice = priceEl.querySelector('.price__regular .price-item--regular');
      const saleCompare = priceEl.querySelector('.price__sale s.price-item--regular');
      const salePrice = priceEl.querySelector('.price__sale .price-item--sale');

      if (regularPrice) {
        regularPrice.textContent = priceMoney;
      }
      if (salePrice) {
        salePrice.textContent = priceMoney;
      }
      if (saleCompare) {
        saleCompare.textContent = compareMoney;
      }

      priceEl.classList.toggle('price--on-sale', onSale);

      if (saveEl) {
        if (onSale && saveLabel) {
          saveEl.textContent = saveLabel;
          saveEl.classList.remove('hidden');
          saveEl.removeAttribute('aria-hidden');
        } else {
          saveEl.textContent = '';
          saveEl.classList.add('hidden');
          saveEl.setAttribute('aria-hidden', 'true');
        }
      }
    }

    setStockState(text, isLow) {
      this.stockEl.textContent = text;
      this.stockEl.classList.toggle('card-inline-sizes__stock--low', Boolean(isLow));
    }
  }

  customElements.define('card-inline-sizes', CardInlineSizes);
}
